import styled from 'styled-components';
import QuickLinksButton from './QuickLinksButton';
import { isSafeLink } from '../utils/isSafeLink';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapper = styled.div.withConfig({
  displayName: "QuickLinksGroup__ButtonWrapper"
})(["gap:8px;padding-top:8px;align-items:center;display:flex;flex-wrap:wrap;width:100%;"]);
const QuickLinksGroup = ({
  options,
  disabled
}) => {
  const renderOptions = () => {
    return options.map(option => {
      const value = option.value;
      const url = option.url;
      if (!value || !url || !isSafeLink(url)) {
        return null;
      }
      return /*#__PURE__*/_jsx(QuickLinksButton, {
        href: url,
        disabled: disabled,
        children: value
      }, `quicklink.${value}`);
    });
  };
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    "data-test-id": "quick-links-group",
    children: renderOptions()
  });
};
QuickLinksGroup.displayName = 'QuickLinksGroup';
export default QuickLinksGroup;